import React from 'react';
import { ProductDiscontinuedBanner } from '@modules/Dashboard/modules/MigrateOffer/modules/ProductDiscontinuedBanner/ProductDiscontinuedBanner';
import { insertIf } from '@utils/insertIf';
import { routing } from '@utils/routing';
import { CombinedAlert } from '../../components/CombinedAlert/CombinedAlert';
export const useProductBanners = ({ offer, product, }) => {
    if (!product || !offer) {
        return { productBanners: [] };
    }
    return {
        productBanners: [
            ...insertIf(product?.status === 'DISCONTINUED', React.createElement(ProductDiscontinuedBanner, { offerId: offer.id ?? '', product: product })),
            ...insertIf(!!offer.parentOffer, React.createElement(CombinedAlert, { combinedLink: routing.products.combined.combinedId.self.replace(':combinedId', offer.parentOffer?.id ?? ''), combinedName: offer.parentOffer?.name ?? '' })),
        ],
    };
};
